import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const SiteAdvantage = ({
	icon,
	title,
	text,
	classComponent,
}) => (
	<StyledCard className={classComponent}>
		<div className="content-header d-flex justify-content-center align-items-center">
			{icon}
		</div>
		<div className="content-title">
			<h4>{title}</h4>
		</div>
		<div className="content-body">{text}</div>
	</StyledCard>
);

PropTypes.Card = {
	icon: PropTypes.elementType,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
};

export default SiteAdvantage;
